import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MarkAllReadMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type MarkAllReadMutation = { __typename?: 'Mutation', markAllNotificationsRead: boolean };


export const MarkAllReadDocument = gql`
    mutation MarkAllRead {
  markAllNotificationsRead
}
    `;
export type MarkAllReadMutationFn = Apollo.MutationFunction<MarkAllReadMutation, MarkAllReadMutationVariables>;

/**
 * __useMarkAllReadMutation__
 *
 * To run a mutation, you first call `useMarkAllReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllReadMutation, { data, loading, error }] = useMarkAllReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllReadMutation, MarkAllReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllReadMutation, MarkAllReadMutationVariables>(MarkAllReadDocument, options);
      }
export type MarkAllReadMutationHookResult = ReturnType<typeof useMarkAllReadMutation>;
export type MarkAllReadMutationResult = Apollo.MutationResult<MarkAllReadMutation>;
export type MarkAllReadMutationOptions = Apollo.BaseMutationOptions<MarkAllReadMutation, MarkAllReadMutationVariables>;